export const text = {
  signUpFree: "Sign Up for Free!",
  signUpdescription: " Enjoy a host of benefits without any commitment.",
  selectCountry: "Select Country",
  emailLabel: "Email / Phone Number",
  emailPlaceholder: "Please enter a valid email or phone number",
  haveAccount: " Already have an account?",
  notReceived: " Not received code yet?",
  resend: "Resend Code",
  there: "  You’re Almost There",
  enjoy: "Enjoy ultra-HD audio/video calling, translation and much more!",
  aOne: "A One stop solution for all your communication needs!",
  emailLabelSignUp: "Sign Up with Email",
  emailPlaceholderSignUp: "Please enter your email",
  numberLabelSignUp: "Sign Up with Phone Number",
};
